import { liteClient as algoliasearch } from 'algoliasearch/lite';
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import { html } from 'htm/preact';

const searchClient = algoliasearch(process.env.MIX_ALGOLIA_APP_ID, process.env.MIX_ALGOLIA_SECRET);

const search = autocomplete({
  container: '#autocomplete',
  getSources() {
    return [
      {
        sourceId: 'querySuggestions',
        getItemInputValue: ({ item }) => item.query,
        getItemUrl({ item }) {
          return item.url;
        },
        getItems({ query }) {
          return getAlgoliaResults({
            searchClient,
            queries: [
              {
                indexName: process.env.MIX_SCOUT_PREFIX + 'teams',
                query,
                params: {
                  filters: 'tenants:"' + TENANT_ID + '" AND active:true',
                  hitsPerPage: 6,
                },
              },
              {
                indexName: process.env.MIX_SCOUT_PREFIX + 'products',
                query,
                params: {
                  filters: 'tenants:"' + TENANT_ID + '"',
                  hitsPerPage: 6,
                },
              },
              {
                indexName: process.env.MIX_SCOUT_PREFIX + 'categories',
                query,
                params: {
                  filters: 'tenants:"' + TENANT_ID + '"',
                  hitsPerPage: 6,
                },
              },
            ],
          });
        },
        templates: {
          item({ item, components }) {
              let htmlReturn = ''
              if (item.model == "team") {
                  htmlReturn = html`
                    <a href="${item.url}" class="w-100 d-flex align-items-center justify-content-between px-2">
                        <div class="d-flex align-items-center">
                            <div class="text-dark">${item.name}</div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="small text-muted">Voir le showroom</div>
                            <i class="text-primary ci-arrow-right-circle ms-2"></i>
                        </div>
                    </a>
                  `
              } else if (item.model == "product") {
                  htmlReturn = html`
                    <a href="${item.url}" class="w-100 d-flex align-items-center justify-content-between px-2">
                        <div class="d-flex align-items-center">
                            <div class="badge bg-secondary fw-bold me-2">${item.brand_name}</div>
                            <div class="text-dark">${item.name}</div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="small text-muted">Voir le produit</div>
                            <i class="text-primary ci-arrow-right-circle ms-2"></i>
                        </div>
                    </a>
                  `
              } else if (item.model == "category") {
                  htmlReturn = html`
                    <a href="${item.url}" class="w-100 d-flex align-items-center justify-content-between px-2">
                        <div class="d-flex align-items-center">
                            <div class="badge bg-secondary fw-bold me-2">${item.themes[1]}</div>
                            <div class="text-dark">${item.name}</div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="small text-muted">Voir la catégorie</div>
                            <i class="text-primary ci-arrow-right-circle ms-2"></i>
                        </div>
                    </a>
                  `
              } else {
                  htmlReturn = item.name
              }
              return htmlReturn
          },
        },
      },
    ];
  },
});

// // Create a render function
// const renderSearchBox = (renderOptions, isFirstRender) => {
//   const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;

//   if (isFirstRender) {
//     const input = document.createElement('input');

//     const loadingIndicator = document.createElement('span');
//     loadingIndicator.textContent = 'Loading...';

//     const button = document.createElement('button');
//     button.textContent = 'X';

//     input.addEventListener('input', event => {
//       refine(event.target.value);
//     });

//     button.addEventListener('click', () => {
//       clear();
//     });

//     widgetParams.container.appendChild(input);
//     widgetParams.container.appendChild(loadingIndicator);
//     widgetParams.container.appendChild(button);
//   }

//   widgetParams.container.querySelector('input').value = query;
//   widgetParams.container.querySelector('span').hidden = !isSearchStalled;
// };

